
<template>
  <div class="wrapper">
    <div class="title" >{{title}}</div>
    <div class="qr" :class="disabled === true ? 'disabled' : ''">
      <div  v-html="qrImg" > </div>
      <v-stamp  v-if="status && status.length > 0" :title='status' color='#898989' class="stamp"></v-stamp>
    </div>

  </div>
</template>
<script>
import qr from 'qr-image'
export default {
  props: {
    qrString: String,
    title: String,
    disabled: Boolean,
    status: String
  },
  data () {
    return {
    }
  },
  computed: {
    qrImg () {
      return qr.imageSync(this.qrString, {type: 'svg'})
    }
  },
  methods: {
  }
}
</script>
<style lang="stylus" scoped>
@import '../css/var'
  .wrapper
    background-color white
    border-radius 10px
    padding pt(50) 0
    height pt(450)
    depth(1)
  .title
    text-align center
    font-size $small-font-size
    font-weight bold
  .qr
    background-color red
    position relative
    margin auto
    width pt(300)
    margin-top pt(20)
    background-color white
    color #CCCCCC
    .stamp
      z-index 9999
      width pt(250)
      height pt(250)
      margin pt(-370) 0 0 pt(150)
  .disabled
    fill-opacity 0.4
</style>



// WEBPACK FOOTER //
// qr-code.vue?a1b12136